"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INITIAL_CONTEXT = exports.STATUS_DISABLED = exports.STATUS_UPLOADING = exports.STATUS_ERROR = exports.STATUS_SUCCESS = exports.STATUS_DEFAULT = void 0;
var STATUS_DEFAULT = 'default';
exports.STATUS_DEFAULT = STATUS_DEFAULT;
var STATUS_SUCCESS = 'success';
exports.STATUS_SUCCESS = STATUS_SUCCESS;
var STATUS_ERROR = 'error';
exports.STATUS_ERROR = STATUS_ERROR;
var STATUS_UPLOADING = 'uploading';
exports.STATUS_UPLOADING = STATUS_UPLOADING;
var STATUS_DISABLED = 'disabled';
exports.STATUS_DISABLED = STATUS_DISABLED;
var INITIAL_CONTEXT = {
  title: 'Title',
  description: '',
  extra: {
    children: 'Add',
    icon: 'plus',
    renderIcon: null
  },
  renderExtra: null
};
exports.INITIAL_CONTEXT = INITIAL_CONTEXT;